import { fetch, get } from '@mitchell/typescript.service.fetch';
import { EnvironmentService, HttpCacheType } from "../../common";
/**
 * @class ResourceLookupService handles resource look up api calls
 */
export class ResourceLookupService {
    /*istanbul ignore next*/
    constructor(fetchWrapper = fetch) {
        this.fetchWrapper = fetchWrapper;
        this.apiUrl = EnvironmentService.getEnvironment().appApi;
    }
    static getInstance() {
        if (!ResourceLookupService.instance) {
            ResourceLookupService.instance = new ResourceLookupService();
        }
        return ResourceLookupService.instance;
    }
    /**
     * this method is used to fetch list of resources
     * @param resourceLookupPayload represents the payload required to fetch list of resources
     * @returns IResourceInfoResponse[]
     */
    getResources(resourceLookupPayload) {
        const { assignorCoCd, assignorOrgCode, companyCode, countryCode, zip, radius } = resourceLookupPayload;
        const pragma = { Pragma: HttpCacheType.NO_CACHE };
        const url = `${this.apiUrl}MSOResource/assignorCoCd/${assignorCoCd}/assignorOrgCode/${assignorOrgCode}/coCode/${companyCode}?countryCode=${countryCode}&zip=${zip}&radius=${radius}`;
        const request = new Request(url, {
            cache: HttpCacheType.NO_CACHE
        });
        return get(request, pragma, this.fetchWrapper);
    }
}
//# sourceMappingURL=ResourceLookupService.js.map